module.exports = new __parcel__URL__("cornershop-ipad.8cb34050.png").toString();